module.exports = __webpack_public_path__ + "img/reward-ratio-ilustra.bca72a28.png";